import type { PropsWithChildren } from 'react';

import { BulletedListItem } from './components/ListItem'
import { BulletedListStyled } from './styles/BulletedListStyled'

export interface IBulletedListProps {}

export const BulletedList = ({
  children,
}: PropsWithChildren<IBulletedListProps>) => {
  return <BulletedListStyled>{children}</BulletedListStyled>
}

BulletedList.Item = BulletedListItem
